import { render, staticRenderFns } from "./receiptComponent.vue?vue&type=template&id=fb5936d8&scoped=true&"
import script from "./receiptComponent.vue?vue&type=script&lang=js&"
export * from "./receiptComponent.vue?vue&type=script&lang=js&"
import style0 from "./receiptComponent.vue?vue&type=style&index=0&id=fb5936d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5936d8",
  null
  
)

export default component.exports